const ID = {
    SPORSMAL: {
        FORSIKRINGS_EIER: 'ForsikringsEier',
    },
    SVAR: {
        JA_NEI_SPORSMAL_SVAR_JA: 'JaEllerNei_Alternativ_Ja',
    },
};

export default ID;
